import type { TrpcClient } from "@common/api-interface/trpc-client";
import type { User, UserId } from "@common/types/user";
import { reduceToMap } from "@common/utils/array-utils";
import { observable, runInAction } from "mobx";

export interface MakeTimerStoreDeps {
  trpcClient: TrpcClient;
}

export default class UserDetailsStore {
  @observable
  userDetailsCache: Record<UserId, User> = {};

  constructor(readonly deps: MakeTimerStoreDeps) {}

  async loadUserDetails(userIds: UserId[]) {
    const userDetails = (
      await this.deps.trpcClient.users.getUserDetails.query({ userIds })
    ).reduce(reduceToMap, {});
    runInAction(() => {
      this.userDetailsCache = { ...this.userDetailsCache, ...userDetails };
    });
  }

  getUserDetail(userId: UserId): User | null {
    return this.userDetailsCache[userId] || null;
  }
}
